import React, { useState, useEffect } from "react";
import { Plus, Database, FileText, Activity, Layers, Package, Warehouse as WarehouseIcon, ChevronRight, ChevronDown, List, Trash2, Edit } from "lucide-react";
import { Card, PageHeader, Btn, Input, Select, Field, Modal, Table, Spinner, ErrBox } from "../components/UI";
import Badge from "../components/Badge";
import { fmtRp, fmtDate } from "../utils/format";
import { masterAPI } from "../utils/api";

const MasterPage = () => {
  const [tab, setTab]             = useState("vendor");
  const [vendors, setVendors]     = useState([]);
  const [coa, setCoa]             = useState([]);
  const [units, setUnits]         = useState([]);
  const [costCenters, setCostCenters] = useState([]);
  const [items, setItems]         = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [loading, setLoading]     = useState(false);
  const [saving, setSaving]       = useState(false);
  const [search, setSearch]       = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [vendorForm, setVendorForm] = useState({ kode:"", nama:"", npwp:"", telepon:"", email:"", alamat:"", nama_bank:"", no_rekening:"", atas_nama:"" });
  const [coaForm, setCoaForm]     = useState({ kode:"", nama:"", tipe:"BELANJA", level:3 });
  const [ccForm, setCcForm]       = useState({ kode:"", nama:"", deskripsi:"", parent_id:"", unit_kerja_id:"", kepala_cc:"", email_kepala:"", program_id:"", kegiatan_id:"", kro_id:"", akun_id:"" });
  const [itemForm, setItemForm]   = useState({ kode:"", nama:"", deskripsi:"", kategori:"BARANG", satuan:"UNIT", spesifikasi:"", merk:"", no_part:"", harga_estimasi:"", cost_center_id:"", akun_hpp_id:"", akun_stok_id:"", min_stok:"", max_stok:"" });
  const [warehouseForm, setWarehouseForm] = useState({ kode:"", nama:"", deskripsi:"", alamat:"", kota:"", penanggung_jawab:"", telepon:"", email:"", tipe:"GUDANG", kapasitas:"", unit_kerja_id:"", cost_center_id:"" });
  const [parentOptions, setParentOptions] = useState([]);
  const [unitOptions, setUnitOptions]     = useState([]);
  const [ccOptions, setCcOptions]         = useState([]);
  const [coaOptions, setCoaOptions]       = useState([]);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailAkun, setDetailAkun]         = useState(null);
  const [detailItems, setDetailItems]       = useState([]);
  const [detailForm, setDetailForm]       = useState({ suffix:"", nama:"", pagu_awal:"", revisi_1:"", revisi_2:"" });
  const [detailSaving, setDetailSaving]    = useState(false);
  // COA Hierarchy States
  const [coaPrograms, setCoaPrograms]     = useState([]);
  const [coaKegiatan, setCoaKegiatan]     = useState([]);
  const [coaKros, setCoaKros]             = useState([]);
  const [coaAkuns, setCoaAkuns]           = useState([]);
  const [coaDetails, setCoaDetails]       = useState([]);
  const [coaDropdowns, setCoaDropdowns]   = useState({ program:[], kegiatan:[], kro:[], akun:[], detail_akun:[] });
  const [coaForm2, setCoaForm2] = useState({ level:"program", kode:"", nama:"", program_id:"", kegiatan_id:"", kro_id:"", jenis:"BELANJA", akun_id:"" });

  const loadTab = async (t = tab, s = "") => {
    setLoading(true);
    try {
      if (t === "vendor") { const r = await masterAPI.getVendor(`?limit=200${s?`&search=${s}`:""}`); setVendors(r.data||[]); }
      if (t === "coa")    { const r = await masterAPI.getCOA(`?limit=200${s?`&search=${s}`:""}`);    setCoa(r.data||[]); }
      if (t === "unit")   { const r = await masterAPI.getUnit(`?limit=200${s?`&search=${s}`:""}`);   setUnits(r.data||[]); }
      if (t === "costcenter") {
        try {
          console.log('Loading cost center data...');
          const [rCC, rUnit, rOpts, rKegs, rKros, rAkun] = await Promise.all([
            masterAPI.getCostCenter(`?limit=200${s?`&search=${s}`:""}`),
            masterAPI.getUnit(`?limit=500`),
            masterAPI.getCoaOptions(),
            masterAPI.getCoaKegiatan(),
            masterAPI.getCoaKro(),
            masterAPI.getCoaAkun()
          ]);
          console.log('Cost center data:', rCC.data?.length || 0, 'items');
          setCostCenters(rCC.data||[]);
          setUnitOptions((rUnit.data||[]).map(u=>({value:u.id,label:u.nama})));
          setParentOptions(rCC.data.map(cc=>({value:cc.id,label:`${cc.kode} - ${cc.nama}`})));
          setCoaDropdowns({
            program: (rOpts.data?.program||[]).map(p=>({value:p.id,label:`${p.kode} - ${p.nama}`})),
            kegiatan: (rKegs.data||[]).map(k=>({value:k.id,label:`${k.program_kode||'-'} - ${k.kode} - ${k.nama}`})),
            kro: (rKros.data||[]).map(k=>({value:k.id,label:`${k.program_kode||'-'} - ${k.kegiatan_kode||'-'} - ${k.kode} - ${k.nama}`})),
            akun: (rAkun.data||[]).map(a=>({value:a.id,label:`${a.program_kode||'-'} > ${a.kegiatan_kode||'-'} > ${a.kro_kode||'-'} | ${a.kode} - ${a.nama} (${a.jenis})`}))
          });
        } catch (err) {
          console.error('Error loading cost center data:', err);
          // Fallback: tetap tampilkan data cost center meskipun dropdown gagal
          const rCC = await masterAPI.getCostCenter(`?limit=200${s?`&search=${s}`:""}`);
          console.log('Fallback cost center data:', rCC.data?.length || 0, 'items');
          setCostCenters(rCC.data||[]);
        }
      }
      if (t === "item") {
        const [rItem, rCC, rCOA] = await Promise.all([
          masterAPI.get(`item?limit=200${s?`&search=${s}`:""}`),
          masterAPI.getCostCenter(`?limit=500`),
          masterAPI.getCOA(`?limit=500`)
        ]);
        setItems(rItem.data||[]);
        setCcOptions((rCC.data||[]).map(cc=>({value:cc.id,label:`${cc.kode} - ${cc.nama}`})));
        setCoaOptions((rCOA.data||[]).map(coa=>({value:coa.id,label:`${coa.kode} - ${coa.nama}`})));
      }
      if (t === "warehouse") {
        const [rWh, rUnit, rCC] = await Promise.all([
          masterAPI.get(`warehouse?limit=200${s?`&search=${s}`:""}`),
          masterAPI.getUnit(`?limit=500`),
          masterAPI.getCostCenter(`?limit=500`)
        ]);
        setWarehouses(rWh.data||[]);
        setUnitOptions((rUnit.data||[]).map(u=>({value:u.id,label:u.nama})));
        setCcOptions((rCC.data||[]).map(cc=>({value:cc.id,label:`${cc.kode} - ${cc.nama}`})));
      }
      if (t === "coa2") {
        const [opts, progs, kegs, kros, akuns, details] = await Promise.all([
          masterAPI.getCoaOptions(),
          masterAPI.getCoaProgram(),
          masterAPI.getCoaKegiatan(),
          masterAPI.getCoaKro(),
          masterAPI.getCoaAkun(),
          masterAPI.getCoaDetailAkun(),
        ]);
setCoaDropdowns({
          program: (opts.data?.program||[]).map(p=>({value:p.id,label:`${p.kode} - ${p.nama}`})),
          kegiatan: (kegs.data||[]).map(k=>({value:k.id,label:`${k.program_kode||'-'} - ${k.kode} - ${k.nama}`})),
          kro: (kros.data||[]).map(k=>({value:k.id,label:`${k.program_kode||'-'} - ${k.kegiatan_kode||'-'} - ${k.kode} - ${k.nama}`})),
          akun: (akuns.data||[]).map(a=>({value:a.id,label:`${a.program_kode||'-'} > ${a.kegiatan_kode||'-'} > ${a.kro_kode||'-'} | ${a.kode} - ${a.nama} (${a.jenis})`})),
          detail_akun: (opts.data?.detail_akun||[]).map(d=>({value:d.id,label:`${d.kode} - ${d.nama}`})),
        });
        setCoaPrograms(progs.data||[]);
        setCoaKegiatan(kegs.data||[]);
        setCoaKros(kros.data||[]);
        setCoaAkuns(akuns.data||[]);
        setCoaDetails(details.data||[]);
      }
    } catch(e) { console.error(e); }
    finally { setLoading(false); }
  };

  useEffect(() => { setSearch(""); loadTab(tab, ""); }, [tab]);

  const handleSaveVendor = async () => {
    if (!vendorForm.kode || !vendorForm.nama) return;
    setSaving(true);
    try {
      await masterAPI.create("vendor", vendorForm);
      setShowModal(false);
      setVendorForm({ kode:"", nama:"", npwp:"", telepon:"", email:"", alamat:"", nama_bank:"", no_rekening:"", atas_nama:"" });
      loadTab("vendor");
    } catch(e) { alert("Gagal: " + e.message); }
    finally { setSaving(false); }
  };

  const handleSaveCoa = async () => {
    if (!coaForm.kode || !coaForm.nama) return;
    setSaving(true);
    try {
      await masterAPI.create("coa", coaForm);
      setShowModal(false);
      setCoaForm({ kode:"", nama:"", tipe:"BELANJA", level:3 });
      loadTab("coa");
    } catch(e) { alert("Gagal: " + e.message); }
    finally { setSaving(false); }
  };

  const handleSaveCC = async () => {
    if (!ccForm.kode || !ccForm.nama) return;
    setSaving(true);
    try {
      await masterAPI.create("cost-center", ccForm);
      setShowModal(false);
      setCcForm({ kode:"", nama:"", deskripsi:"", parent_id:"", unit_kerja_id:"", kepala_cc:"", email_kepala:"", program_id:"", kegiatan_id:"", kro_id:"", akun_id:"" });
      loadTab("costcenter");
    } catch(e) { alert("Gagal: " + e.message); }
    finally { setSaving(false); }
  };

  const handleSaveItem = async () => {
    if (!itemForm.kode || !itemForm.nama) return;
    setSaving(true);
    try {
      await masterAPI.create("item", itemForm);
      setShowModal(false);
      setItemForm({ kode:"", nama:"", deskripsi:"", kategori:"BARANG", satuan:"UNIT", spesifikasi:"", merk:"", no_part:"", harga_estimasi:"", cost_center_id:"", akun_hpp_id:"", akun_stok_id:"", min_stok:"", max_stok:"" });
      loadTab("item");
    } catch(e) { alert("Gagal: " + e.message); }
    finally { setSaving(false); }
  };

  const handleSaveWarehouse = async () => {
    if (!warehouseForm.kode || !warehouseForm.nama) return;
    setSaving(true);
    try {
      await masterAPI.create("warehouse", warehouseForm);
      setShowModal(false);
      setWarehouseForm({ kode:"", nama:"", deskripsi:"", alamat:"", kota:"", penanggung_jawab:"", telepon:"", email:"", tipe:"GUDANG", kapasitas:"", unit_kerja_id:"", cost_center_id:"" });
      loadTab("warehouse");
    } catch(e) { alert("Gagal: " + e.message); }
    finally { setSaving(false); }
  };

  const tabs = [
    { key:"vendor", label:"Vendor",           icon:<Database size={14}/> },
    { key:"coa2",   label:"COA Hirarki",       icon:<Layers size={14}/> },
    { key:"unit",   label:"Unit Kerja",        icon:<Activity size={14}/> },
    { key:"costcenter", label:"Cost Center",   icon:<Layers size={14}/> },
    { key:"item",   label:"Item Master",       icon:<Package size={14}/> },
    { key:"warehouse", label:"Warehouse",      icon:<WarehouseIcon size={14}/> },
  ];

  return (
    <div>
      <PageHeader title="Master Data" subtitle="Pengelolaan data referensi sistem"
        action={tab !== "unit" && <Btn icon={<Plus size={14}/>} onClick={()=>setShowModal(true)}>Tambah {tabs.find(t=>t.key===tab)?.label}</Btn>}
      />
      <div style={{ display:"flex", gap:8, marginBottom:20 }}>
        {tabs.map(t=>(
          <button key={t.key} onClick={()=>setTab(t.key)}
            style={{ display:"flex", alignItems:"center", gap:6, padding:"8px 16px", borderRadius:8,
              border:"1.5px solid", cursor:"pointer", fontSize:13, fontWeight:600, fontFamily:"inherit",
              background:tab===t.key?"#2563EB":"white", color:tab===t.key?"white":"#6B7280",
              borderColor:tab===t.key?"#2563EB":"#E5E7EB" }}>
            {t.icon} {t.label}
          </button>
        ))}
      </div>
      <Card>
        <div style={{ marginBottom:16 }}>
          <Input value={search} onChange={e=>setSearch(e.target.value)} onBlur={()=>loadTab(tab,search)}
            placeholder={`Cari ${tabs.find(t=>t.key===tab)?.label.toLowerCase()}…`} style={{ maxWidth:360 }}/>
        </div>
        {loading ? <Spinner/> : (
          <>
            {tab==="vendor" && <Table pageSize={10} cols={[
              { key:"kode",        label:"Kode" },
              { key:"nama",        label:"Nama Vendor" },
              { key:"npwp",        label:"NPWP" },
              { key:"nama_bank",   label:"Bank" },
              { key:"no_rekening", label:"No. Rekening" },
              { key:"status",      label:"Status", render:v=><Badge status={v}/> },
            ]} data={vendors}/>}
            {tab==="coa2" && (
              <div>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
                  <div style={{ fontSize:13, color:"#6B7280" }}>Program → Kegiatan → KRO → Akun MA → Detail</div>
                  <Btn icon={<Plus size={14}/>} onClick={()=>{ setEditingItem(null); setCoaForm2({ level:"program", kode:"", nama:"", program_id:"", kegiatan_id:"", kro_id:"", jenis:"BELANJA" }); setShowModal(true); }}>
                    Tambah {coaForm2.level==="program"?"Program":coaForm2.level==="kegiatan"?"Kegiatan":coaForm2.level==="kro"?"KRO":coaForm2.level==="akun"?"Akun MA":"Detail"}
                  </Btn>
                </div>
                <div style={{ marginBottom:12, display:"flex", gap:8 }}>
                  {["program","kegiatan","kro","akun","detail"].map(lvl=>(
                    <button key={lvl} onClick={()=>setCoaForm2(f=>({...f,level:lvl}))}
                      style={{ padding:"4px 14px", borderRadius:6, border:"1.5px solid", cursor:"pointer", fontSize:12, fontWeight:600,
                        background:coaForm2.level===lvl?"#2563EB":"white", color:coaForm2.level===lvl?"white":"#6B7280",
                        borderColor:coaForm2.level===lvl?"#2563EB":"#E5E7EB" }}>
                      {lvl==="detail"?"DETAIL":lvl.toUpperCase()}
                    </button>
                  ))}
                </div>
                <Table pageSize={20} cols={[
                  { key:"kode", label:"Kode", render:v=><span style={{fontFamily:"monospace",fontWeight:700,color:"#2563EB"}}>{v}</span> },
                  { key:"nama", label:"Nama" },
                  ...(coaForm2.level==="program"?[]:[{ key:"program_kode"||"program_nama", label:"Induk Program", render:(_,row)=>row.program_kode?<span style={{fontSize:11,background:"#F3F4F6",padding:"2px 6px",borderRadius:4,fontFamily:"monospace"}}>{row.program_kode}</span>:"-" }]),
                  ...(coaForm2.level==="kro"?[{ key:"kegiatan_kode"||"kegiatan_nama", label:"Induk Kegiatan", render:(_,row)=>row.kegiatan_kode?<span style={{fontSize:11,background:"#F3F4F6",padding:"2px 6px",borderRadius:4,fontFamily:"monospace"}}>{row.kegiatan_kode}</span>:"-" }]:[]),
                  ...(coaForm2.level==="detail"?[{ key:"akun_kode"||"akun_nama", label:"Induk Akun MA", render:(_,row)=>row.akun_kode?<span style={{fontSize:11,background:"#DCFCE7",padding:"2px 6px",borderRadius:4,fontFamily:"monospace"}}>{row.akun_kode}</span>:"-" }]:[]),
                  ...(coaForm2.level==="akun"?[
                    { key:"jenis", label:"Jenis", render:v=><span style={{fontSize:10,fontWeight:700,textTransform:"uppercase",padding:"2px 8px",borderRadius:99,background:v==="BELANJA"?"#FEE2E2":"#D1FAE5",color:v==="BELANJA"?"#991B1B":"#065F46"}}>{v}</span> },
                    { key:"total_pagu", label:"Total Pagu", render:v=><span style={{fontFamily:"monospace"}}>{v?fmtRp(Number(v)):"-"}</span> },
                  ]:[]),
                  { key:"id", label:"Aksi", align:"center", render:(_,row)=>(
                    <div style={{display:"flex",gap:4,justifyContent:"center"}}>
                      <button onClick={()=>{ setEditingItem(row); setCoaForm2({ level:coaForm2.level, kode:row.kode, nama:row.nama, program_id:row.program_id||"", kegiatan_id:row.kegiatan_id||"", kro_id:row.kro_id||"", jenis:row.jenis||"BELANJA", akun_id:row.akun_id||"" }); setShowModal(true); }} style={{padding:"4px 8px",borderRadius:4,border:"1px solid #E5E7EB",background:"white",cursor:"pointer",fontSize:11}}><Edit size={12}/></button>
                    </div>
                  )},
                ]} data={coaForm2.level==="program"?coaPrograms:coaForm2.level==="kegiatan"?coaKegiatan:coaForm2.level==="kro"?coaKros:coaForm2.level==="akun"?coaAkuns:coaDetails}/>
              </div>
            )}
            {tab==="unit" && <Table pageSize={10} cols={[
              { key:"kode",   label:"Kode" },
              { key:"nama",   label:"Nama Unit" },
              { key:"kepala", label:"Kepala Unit" },
              { key:"status", label:"Status", render:v=><Badge status={v}/> },
            ]} data={units}/>}
            {tab==="costcenter" && <Table pageSize={10} cols={[
              { key:"kode",           label:"Kode" },
              { key:"nama",           label:"Nama Cost Center" },
              { key:"unit_nama",      label:"Unit Kerja" },
              { key:"kepala_cc",      label:"Kepala CC" },
              { key:"program_kode",   label:"Program", render:(v,r)=>v?<span style={{fontSize:11,fontFamily:"monospace",background:"#EEF2FF",padding:"2px 6px",borderRadius:4,color:"#4338CA"}}>{v}</span>:<span style={{color:"#9CA3AF"}}>-</span> },
              { key:"kegiatan_kode",  label:"Kegiatan", render:(v,r)=>v?<span style={{fontSize:11,fontFamily:"monospace",background:"#FEF3C7",padding:"2px 6px",borderRadius:4,color:"#92400E"}}>{v}</span>:<span style={{color:"#9CA3AF"}}>-</span> },
              { key:"kro_kode",       label:"KRO", render:(v,r)=>v?<span style={{fontSize:11,fontFamily:"monospace",background:"#DCFCE7",padding:"2px 6px",borderRadius:4,color:"#166534"}}>{v}</span>:<span style={{color:"#9CA3AF"}}>-</span> },
              { key:"akun_kode",      label:"Akun MA", render:(v,r)=>v?<span style={{fontSize:11,fontFamily:"monospace",fontWeight:700,color:"#2563EB"}}>{v}</span>:<span style={{color:"#9CA3AF"}}>-</span> },
              { key:"status",         label:"Status", render:v=><Badge status={v}/> },
            ]} data={costCenters}/>}
            {tab==="item" && <Table pageSize={10} cols={[
              { key:"kode",            label:"Kode" },
              { key:"nama",            label:"Nama Item" },
              { key:"kategori",        label:"Kategori" },
              { key:"satuan",          label:"Satuan" },
              { key:"merk",            label:"Merk" },
              { key:"harga_estimasi",  label:"Harga Estimasi", render:v=>v?`Rp ${Number(v).toLocaleString('id')}`:'-' },
              { key:"status",          label:"Status", render:v=><Badge status={v}/> },
            ]} data={items}/>}
            {tab==="warehouse" && <Table pageSize={10} cols={[
              { key:"kode",               label:"Kode" },
              { key:"nama",               label:"Nama Warehouse" },
              { key:"tipe",               label:"Tipe" },
              { key:"alamat",             label:"Alamat" },
              { key:"penanggung_jawab",   label:"Penanggung Jawab" },
              { key:"telepon",            label:"Telepon" },
              { key:"status",             label:"Status", render:v=><Badge status={v}/> },
            ]} data={warehouses}/>}
          </>
        )}
      </Card>

      {showModal && tab==="vendor" && (
        <Modal title="Tambah Vendor" onClose={()=>setShowModal(false)}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 16px" }}>
            <Field label="Kode" required><Input value={vendorForm.kode} onChange={e=>setVendorForm({...vendorForm,kode:e.target.value})} placeholder="VND-010"/></Field>
            <Field label="Nama Vendor" required><Input value={vendorForm.nama} onChange={e=>setVendorForm({...vendorForm,nama:e.target.value})} placeholder="PT Nama Vendor"/></Field>
            <Field label="NPWP"><Input value={vendorForm.npwp} onChange={e=>setVendorForm({...vendorForm,npwp:e.target.value})} placeholder="00.000.000.0-000.000"/></Field>
            <Field label="Telepon"><Input value={vendorForm.telepon} onChange={e=>setVendorForm({...vendorForm,telepon:e.target.value})} placeholder="021-xxxxxxx"/></Field>
            <Field label="Email"><Input value={vendorForm.email} onChange={e=>setVendorForm({...vendorForm,email:e.target.value})} placeholder="vendor@email.com"/></Field>
            <Field label="Bank"><Input value={vendorForm.nama_bank} onChange={e=>setVendorForm({...vendorForm,nama_bank:e.target.value})} placeholder="BRI / BNI / Mandiri"/></Field>
            <Field label="No. Rekening"><Input value={vendorForm.no_rekening} onChange={e=>setVendorForm({...vendorForm,no_rekening:e.target.value})} placeholder="00000000000"/></Field>
            <Field label="Atas Nama"><Input value={vendorForm.atas_nama} onChange={e=>setVendorForm({...vendorForm,atas_nama:e.target.value})} placeholder="Nama pemilik rekening"/></Field>
          </div>
          <Field label="Alamat"><Input value={vendorForm.alamat} onChange={e=>setVendorForm({...vendorForm,alamat:e.target.value})} placeholder="Alamat lengkap"/></Field>
          <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
            <Btn variant="secondary" onClick={()=>setShowModal(false)}>Batal</Btn>
            <Btn onClick={handleSaveVendor} disabled={saving}>{saving?"Menyimpan…":"Simpan"}</Btn>
          </div>
        </Modal>
      )}

      {showModal && tab==="coa" && (
        <Modal title="Tambah Akun COA" onClose={()=>setShowModal(false)}>
          <Field label="Kode Akun" required><Input value={coaForm.kode} onChange={e=>setCoaForm({...coaForm,kode:e.target.value})} placeholder="5.2.04"/></Field>
          <Field label="Nama Akun" required><Input value={coaForm.nama} onChange={e=>setCoaForm({...coaForm,nama:e.target.value})} placeholder="Belanja Sewa"/></Field>
          <Field label="Tipe">
            <Select value={coaForm.tipe} onChange={e=>setCoaForm({...coaForm,tipe:e.target.value})}
              options={["PENDAPATAN","BELANJA","PEMBIAYAAN"].map(v=>({value:v,label:v}))}/>
          </Field>
          <Field label="Level">
            <Select value={String(coaForm.level)} onChange={e=>setCoaForm({...coaForm,level:Number(e.target.value)})}
              options={["1","2","3"].map(v=>({value:v,label:`Level ${v}`}))}/>
          </Field>
          <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
            <Btn variant="secondary" onClick={()=>setShowModal(false)}>Batal</Btn>
            <Btn onClick={handleSaveCoa} disabled={saving}>{saving?"Menyimpan…":"Simpan"}</Btn>
          </div>
        </Modal>
      )}

      {showModal && tab==="costcenter" && (
        <Modal title="Tambah Cost Center" onClose={()=>setShowModal(false)} wide>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"12px 16px" }}>
            <Field label="Kode" required><Input value={ccForm.kode} onChange={e=>setCcForm({...ccForm,kode:e.target.value})} placeholder="CC-001"/></Field>
            <Field label="Nama Cost Center" required style={{gridColumn:"2/-1"}}><Input value={ccForm.nama} onChange={e=>setCcForm({...ccForm,nama:e.target.value})} placeholder="Umum"/></Field>
            <Field label="Parent (Opsional)">
              <Select value={ccForm.parent_id} onChange={e=>setCcForm({...ccForm,parent_id:e.target.value})} options={[{value:"",label:"-- Tidak Ada --"}, ...parentOptions]}/>
            </Field>
            <Field label="Unit Kerja">
              <Select value={ccForm.unit_kerja_id} onChange={e=>setCcForm({...ccForm,unit_kerja_id:e.target.value})} options={[{value:"",label:"-- Tidak Ada --"}, ...unitOptions]}/>
            </Field>
            <Field label="Program">
              <Select value={ccForm.program_id} onChange={e=>setCcForm({...ccForm,program_id:e.target.value,kegiatan_id:"",kro_id:"",akun_id:""})} options={[{value:"",label:"-- Tidak Ada --"}, ...(coaDropdowns.program||[])]}/>
            </Field>
            <Field label="Kegiatan">
              <Select value={ccForm.kegiatan_id} onChange={e=>setCcForm({...ccForm,kegiatan_id:e.target.value,kro_id:"",akun_id:""})} options={[{value:"",label:"-- Tidak Ada --"}, ...(coaDropdowns.kegiatan||[]).filter(k=>!ccForm.program_id || k.program_id===ccForm.program_id)]}/>
            </Field>
            <Field label="KRO">
              <Select value={ccForm.kro_id} onChange={e=>setCcForm({...ccForm,kro_id:e.target.value,akun_id:""})} options={[{value:"",label:"-- Tidak Ada --"}, ...(coaDropdowns.kro||[]).filter(kr=>!ccForm.kegiatan_id || kr.kegiatan_id===ccForm.kegiatan_id)]}/>
            </Field>
            <Field label="Akun MA">
              <Select value={ccForm.akun_id} onChange={e=>setCcForm({...ccForm,akun_id:e.target.value})} options={[{value:"",label:"-- Tidak Ada --"}, ...(coaDropdowns.akun||[]).filter(a=>!ccForm.kro_id || a.kro_id===ccForm.kro_id)]}/>
            </Field>
            <Field label="Kepala CC"><Input value={ccForm.kepala_cc} onChange={e=>setCcForm({...ccForm,kepala_cc:e.target.value})} placeholder="Nama kepala cost center"/></Field>
            <Field label="Email" style={{gridColumn:"2/-1"}}><Input value={ccForm.email_kepala} onChange={e=>setCcForm({...ccForm,email_kepala:e.target.value})} placeholder="kepala@email.com"/></Field>
          </div>
          <Field label="Deskripsi" style={{marginTop:12}}><Input value={ccForm.deskripsi} onChange={e=>setCcForm({...ccForm,deskripsi:e.target.value})} placeholder="Deskripsi cost center"/></Field>
          <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:20, paddingTop:16, borderTop:"1px solid #E5E7EB" }}>
            <Btn variant="secondary" onClick={()=>setShowModal(false)}>Batal</Btn>
            <Btn onClick={handleSaveCC} disabled={saving}>{saving?"Menyimpan…":"Simpan"}</Btn>
          </div>
        </Modal>
      )}

      {showModal && tab==="item" && (
        <Modal title="Tambah Item" onClose={()=>setShowModal(false)}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 16px" }}>
            <Field label="Kode" required><Input value={itemForm.kode} onChange={e=>setItemForm({...itemForm,kode:e.target.value})} placeholder="ITEM-001"/></Field>
            <Field label="Nama Item" required><Input value={itemForm.nama} onChange={e=>setItemForm({...itemForm,nama:e.target.value})} placeholder="Nama item"/></Field>
            <Field label="Kategori">
              <Select value={itemForm.kategori} onChange={e=>setItemForm({...itemForm,kategori:e.target.value})}
                options={["BARANG","JASA","AKTIVA","LAINNYA"].map(v=>({value:v,label:v}))}/>
            </Field>
            <Field label="Satuan">
              <Select value={itemForm.satuan} onChange={e=>setItemForm({...itemForm,satuan:e.target.value})}
                options={["UNIT","PCS","KG","TON","LITER","METER","BOX","ROLL","SET","PAK"].map(v=>({value:v,label:v}))}/>
            </Field>
            <Field label="Merk"><Input value={itemForm.merk} onChange={e=>setItemForm({...itemForm,merk:e.target.value})} placeholder="Merk item"/></Field>
            <Field label="No. Part"><Input value={itemForm.no_part} onChange={e=>setItemForm({...itemForm,no_part:e.target.value})} placeholder="Nomor part"/></Field>
            <Field label="Harga Estimasi"><Input type="number" value={itemForm.harga_estimasi} onChange={e=>setItemForm({...itemForm,harga_estimasi:e.target.value})} placeholder="0"/></Field>
            <Field label="Cost Center">
              <Select value={itemForm.cost_center_id} onChange={e=>setItemForm({...itemForm,cost_center_id:e.target.value})} options={[{value:"",label:"-- Tidak Ada --"}, ...ccOptions]}/>
            </Field>
          </div>
          <Field label="Akun HPP">
            <Select value={itemForm.akun_hpp_id} onChange={e=>setItemForm({...itemForm,akun_hpp_id:e.target.value})} options={[{value:"",label:"-- Pilih Akun --"}, ...coaOptions]}/>
          </Field>
          <Field label="Akun Stok">
            <Select value={itemForm.akun_stok_id} onChange={e=>setItemForm({...itemForm,akun_stok_id:e.target.value})} options={[{value:"",label:"-- Pilih Akun --"}, ...coaOptions]}/>
          </Field>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 16px" }}>
            <Field label="Min Stok"><Input type="number" value={itemForm.min_stok} onChange={e=>setItemForm({...itemForm,min_stok:e.target.value})} placeholder="0"/></Field>
            <Field label="Max Stok"><Input type="number" value={itemForm.max_stok} onChange={e=>setItemForm({...itemForm,max_stok:e.target.value})} placeholder="0"/></Field>
          </div>
          <Field label="Spesifikasi"><Input value={itemForm.spesifikasi} onChange={e=>setItemForm({...itemForm,spesifikasi:e.target.value})} placeholder="Spesifikasi detail item"/></Field>
          <Field label="Deskripsi"><Input value={itemForm.deskripsi} onChange={e=>setItemForm({...itemForm,deskripsi:e.target.value})} placeholder="Deskripsi singkat"/></Field>
          <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
            <Btn variant="secondary" onClick={()=>setShowModal(false)}>Batal</Btn>
            <Btn onClick={handleSaveItem} disabled={saving}>{saving?"Menyimpan…":"Simpan"}</Btn>
          </div>
        </Modal>
      )}

      {showModal && tab==="coa2" && (
        <Modal title={editingItem?"Edit":"Tambah"} onClose={()=>setShowModal(false)}>
          <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
              <Field label="Level">
                <Select value={coaForm2.level} onChange={e=>setCoaForm2(f=>({...f,level:e.target.value}))}
                  options={[{value:"program",label:"Program"},{value:"kegiatan",label:"Kegiatan"},{value:"kro",label:"KRO/RO"},{value:"akun",label:"Akun MA"},{value:"detail",label:"Detail Akun"}]}/>
              </Field>
              {coaForm2.level==="program" && <Field label="Kode Program" required><Input value={coaForm2.kode} onChange={e=>setCoaForm2(f=>({...f,kode:e.target.value}))} placeholder="6507"/></Field>}
              {coaForm2.level==="kegiatan" && <Field label="Kode Kegiatan" required><Input value={coaForm2.kode} onChange={e=>setCoaForm2(f=>({...f,kode:e.target.value}))} placeholder="2034"/></Field>}
              {coaForm2.level==="kro" && <Field label="Kode KRO" required><Input value={coaForm2.kode} onChange={e=>setCoaForm2(f=>({...f,kode:e.target.value}))} placeholder="001.052"/></Field>}
              {coaForm2.level==="akun" && <Field label="Kode Akun (6 digit)" required><Input value={coaForm2.kode} maxLength={6} onChange={e=>setCoaForm2(f=>({...f,kode:e.target.value}))} placeholder="521111"/></Field>}
              {coaForm2.level==="detail" && <Field label="Kode Detail" required><Input value={coaForm2.kode} onChange={e=>setCoaForm2(f=>({...f,kode:e.target.value}))} placeholder="001"/></Field>}
            </div>
            {coaForm2.level==="program" && <Field label="Nama Program" required><Input value={coaForm2.nama} onChange={e=>setCoaForm2(f=>({...f,nama:e.target.value}))} placeholder="Penyelenggaraan Kesehatan Matra Darat"/></Field>}
            {coaForm2.level==="kegiatan" && <>
              <Field label="Induk Program" required>
                <Select value={coaForm2.program_id} onChange={e=>setCoaForm2(f=>({...f,program_id:e.target.value}))}
                  options={[{value:"",label:"-- Pilih Program --"}, ...(coaDropdowns.program||[]).map(p=>({value:p.id,label:`${p.kode} - ${p.nama}`}))]}/>
              </Field>
              <Field label="Nama Kegiatan" required><Input value={coaForm2.nama} onChange={e=>setCoaForm2(f=>({...f,nama:e.target.value}))} placeholder="Sarana Bidang Kesehatan"/></Field>
            </>}
            {coaForm2.level==="kro" && <>
              <Field label="Induk Kegiatan" required>
                <Select value={coaForm2.kegiatan_id} onChange={e=>setCoaForm2(f=>({...f,kegiatan_id:e.target.value}))}
                  options={[{value:"",label:"-- Pilih Kegiatan --"}, ...(coaDropdowns.kegiatan||[]).map(k=>({value:k.id,label:`${k.kode} - ${k.nama}`}))]}/>
              </Field>
              <Field label="Nama KRO/RO" required><Input value={coaForm2.nama} onChange={e=>setCoaForm2(f=>({...f,nama:e.target.value}))} placeholder="Pengadaan Alkes"/></Field>
            </>}
            {coaForm2.level==="akun" && <>
              <Field label="Jenis Akun" required>
                <Select value={coaForm2.jenis} onChange={e=>setCoaForm2(f=>({...f,jenis:e.target.value}))}
                  options={[{value:"BELANJA",label:"Belanja DIPA"},{value:"PENERIMAAN",label:"Penerimaan BLU"}]}/>
              </Field>
              {coaForm2.jenis==="BELANJA" && <Field label="Induk KRO/RO" required>
                <Select value={coaForm2.kro_id} onChange={e=>setCoaForm2(f=>({...f,kro_id:e.target.value}))}
                  options={[{value:"",label:"-- Pilih KRO --"}, ...(coaDropdowns.kro||[]).map(k=>({value:k.id,label:`${k.kode} - ${k.nama}`}))]}/>
              </Field>}
              <Field label="Nama Akun" required><Input value={coaForm2.nama} onChange={e=>setCoaForm2(f=>({...f,nama:e.target.value}))} placeholder="Belanja Keperluan Perkantoran"/></Field>
            </>}
            {coaForm2.level==="detail" && <>
              <Field label="Induk Akun MA" required>
                <Select value={coaForm2.akun_id} onChange={e=>setCoaForm2(f=>({...f,akun_id:e.target.value}))}
                  options={[{value:"",label:"-- Pilih Akun MA --"}, ...(coaDropdowns.akun||[])]}/>
              </Field>
              <Field label="Nama Detail" required><Input value={coaForm2.nama} onChange={e=>setCoaForm2(f=>({...f,nama:e.target.value}))} placeholder="ATK"/></Field>
            </>}
          </div>
          <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:16 }}>
            <Btn variant="secondary" onClick={()=>setShowModal(false)}>Batal</Btn>
            <Btn onClick={async ()=>{
              setSaving(true);
              try {
                const payload = coaForm2.level==="program"?{kode:coaForm2.kode,nama:coaForm2.nama}:
                  coaForm2.level==="kegiatan"?{program_id:coaForm2.program_id,kode:coaForm2.kode,nama:coaForm2.nama}:
                  coaForm2.level==="kro"?{kegiatan_id:coaForm2.kegiatan_id,kode:coaForm2.kode,nama:coaForm2.nama}:
                  {kro_id:coaForm2.kro_id||null,kode:coaForm2.kode,nama:coaForm2.nama,jenis:coaForm2.jenis};
                if (editingItem) {
                  if (coaForm2.level==="program") await masterAPI.updateCoaProgram(editingItem.id, payload);
                  else if (coaForm2.level==="kegiatan") await masterAPI.updateCoaKegiatan(editingItem.id, payload);
                  else if (coaForm2.level==="kro") await masterAPI.updateCoaKro(editingItem.id, payload);
                  else if (coaForm2.level==="akun") await masterAPI.updateCoaAkun(editingItem.id, payload);
                  else if (coaForm2.level==="detail") await masterAPI.updateCoaDetail(editingItem.id, payload);
                } else {
                  if (coaForm2.level==="program") await masterAPI.createCoaProgram(payload);
                  else if (coaForm2.level==="kegiatan") await masterAPI.createCoaKegiatan(payload);
                  else if (coaForm2.level==="kro") await masterAPI.createCoaKro(payload);
                  else if (coaForm2.level==="akun") await masterAPI.createCoaAkun(payload);
                  else if (coaForm2.level==="detail") await masterAPI.create('coa/detail-akun', { akun_id: coaForm2.akun_id, kode: coaForm2.kode, nama: coaForm2.nama });
                }
                setShowModal(false);
                loadTab("coa2");
              } catch(e) { alert("Gagal: " + e.message); }
              finally { setSaving(false); }
            }} disabled={saving}>{saving?"Menyimpan…":"Simpan"}</Btn>
          </div>
        </Modal>
      )}

      {showDetailModal && detailAkun && (
        <Modal title={`Detail Pagu: ${detailAkun.kode} - ${detailAkun.nama}`} onClose={()=>setShowDetailModal(false)} wide>
          <div style={{ maxHeight:500, overflow:"auto" }}>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr 1fr 1fr 1fr 1fr", gap:8, marginBottom:16, padding:12, background:"#F8FAFC", borderRadius:8 }}>
              <Field label="Suffix"><Input value={detailForm.suffix} onChange={e=>setDetailForm(d=>({...d,suffix:e.target.value}))} placeholder="001"/></Field>
              <Field label="Uraian" style={{gridColumn:"span 2"}}><Input value={detailForm.nama} onChange={e=>setDetailForm(d=>({...d,nama:e.target.value}))} placeholder="Kertas dan Alat Tulis"/></Field>
              <Field label="Pagu Awal"><Input type="number" value={detailForm.pagu_awal} onChange={e=>setDetailForm(d=>({...d,pagu_awal:e.target.value}))} placeholder="0"/></Field>
              <Field label="Revisi 1"><Input type="number" value={detailForm.revisi_1} onChange={e=>setDetailForm(d=>({...d,revisi_1:e.target.value}))} placeholder="0"/></Field>
              <Field label="Revisi 2"><Input type="number" value={detailForm.revisi_2} onChange={e=>setDetailForm(d=>({...d,revisi_2:e.target.value}))} placeholder="0"/></Field>
              <div style={{ display:"flex", alignItems:"flex-end" }}>
                <Btn onClick={async ()=>{
                  if (!detailForm.suffix || !detailForm.nama) return alert("Suffix dan Uraian wajib");
                  setDetailSaving(true);
                  try {
                    await masterAPI.createCoaDetail({ akun_id:detailAkun.id, kode:`${detailAkun.kode}.${detailForm.suffix}`, nama:detailForm.nama, pagu_awal:detailForm.pagu_awal||0, revisi_1:detailForm.revisi_1||0, revisi_2:detailForm.revisi_2||0 });
                    const r = await masterAPI.getCoaDetail(`?akun_id=${detailAkun.id}`);
                    setDetailItems(r.data||[]);
                    setDetailForm({suffix:"", nama:"", pagu_awal:"", revisi_1:"", revisi_2:""});
                  } catch(e) { alert("Gagal: " + e.message); }
                  finally { setDetailSaving(false); }
                }} disabled={detailSaving}><List size={14}/> Entri</Btn>
              </div>
            </div>
            <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
              <thead style={{ background:"#F1F5F9" }}>
                <tr>
                  <th style={{padding:"8px 12px",textAlign:"left"}}>Kode</th>
                  <th style={{padding:"8px 12px",textAlign:"left"}}>Uraian</th>
                  <th style={{padding:"8px 12px",textAlign:"right"}}>Pagu Awal</th>
                  <th style={{padding:"8px 12px",textAlign:"right"}}>Revisi 1</th>
                  <th style={{padding:"8px 12px",textAlign:"right"}}>Revisi 2</th>
                  <th style={{padding:"8px 12px",textAlign:"right", background:"#D1FAE5"}}>Pagu Akhir</th>
                </tr>
              </thead>
              <tbody>
                {detailItems.map(d=><tr key={d.id} style={{borderBottom:"1px solid #F1F5F9"}}>
                  <td style={{padding:"8px 12px",fontFamily:"monospace",fontWeight:700,color:"#2563EB"}}>{d.kode}</td>
                  <td style={{padding:"8px 12px"}}>{d.nama}</td>
                  <td style={{padding:"8px 12px",textAlign:"right",fontFamily:"monospace"}}>{fmtRp(Number(d.pagu_awal))}</td>
                  <td style={{padding:"8px 12px",textAlign:"right",fontFamily:"monospace",color:"#D97706"}}>{Number(d.revisi_1)!==0?fmtRp(Number(d.revisi_1)):"-"}</td>
                  <td style={{padding:"8px 12px",textAlign:"right",fontFamily:"monospace",color:"#D97706"}}>{Number(d.revisi_2)!==0?fmtRp(Number(d.revisi_2)):"-"}</td>
                  <td style={{padding:"8px 12px",textAlign:"right",fontFamily:"monospace",fontWeight:700,color:"#059669",background:"#ECFDF5"}}>{fmtRp(Number(d.pagu_akhir))}</td>
                </tr>)}
                {detailItems.length===0 && <tr><td colSpan={6} style={{padding:24,textAlign:"center",color:"#9CA3AF"}}>Belum ada detail pagu.</td></tr>}
              </tbody>
            </table>
          </div>
        </Modal>
      )}
    {showModal && tab==="warehouse" && (
        <Modal title="Tambah Warehouse" onClose={()=>setShowModal(false)}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 16px" }}>
            <Field label="Kode" required><Input value={warehouseForm.kode} onChange={e=>setWarehouseForm({...warehouseForm,kode:e.target.value})} placeholder="GUD-001"/></Field>
            <Field label="Nama Warehouse" required><Input value={warehouseForm.nama} onChange={e=>setWarehouseForm({...warehouseForm,nama:e.target.value})} placeholder="Gudang Utama"/></Field>
            <Field label="Tipe">
              <Select value={warehouseForm.tipe} onChange={e=>setWarehouseForm({...warehouseForm,tipe:e.target.value})}
                options={["GUDANG","TOKO","CABANG","DEPOT","LAINNYA"].map(v=>({value:v,label:v}))}/>
            </Field>
            <Field label="Telepon"><Input value={warehouseForm.telepon} onChange={e=>setWarehouseForm({...warehouseForm,telepon:e.target.value})} placeholder="021-xxxxxxx"/></Field>
            <Field label="Unit Kerja">
              <Select value={warehouseForm.unit_kerja_id} onChange={e=>setWarehouseForm({...warehouseForm,unit_kerja_id:e.target.value})} options={[{value:"",label:"-- Tidak Ada --"}, ...unitOptions]}/>
            </Field>
            <Field label="Cost Center">
              <Select value={warehouseForm.cost_center_id} onChange={e=>setWarehouseForm({...warehouseForm,cost_center_id:e.target.value})} options={[{value:"",label:"-- Tidak Ada --"}, ...ccOptions]}/>
            </Field>
          </div>
          <Field label="Penanggung Jawab"><Input value={warehouseForm.penanggung_jawab} onChange={e=>setWarehouseForm({...warehouseForm,penanggung_jawab:e.target.value})} placeholder="Nama penanggung jawab"/></Field>
          <Field label="Email"><Input value={warehouseForm.email} onChange={e=>setWarehouseForm({...warehouseForm,email:e.target.value})} placeholder="gudang@email.com"/></Field>
          <Field label="Kota"><Input value={warehouseForm.kota} onChange={e=>setWarehouseForm({...warehouseForm,kota:e.target.value})} placeholder="Jakarta"/></Field>
          <Field label="Kapasitas"><Input type="number" value={warehouseForm.kapasitas} onChange={e=>setWarehouseForm({...warehouseForm,kapasitas:e.target.value})} placeholder="0"/></Field>
          <Field label="Alamat"><Input value={warehouseForm.alamat} onChange={e=>setWarehouseForm({...warehouseForm,alamat:e.target.value})} placeholder="Alamat lengkap warehouse"/></Field>
          <Field label="Deskripsi"><Input value={warehouseForm.deskripsi} onChange={e=>setWarehouseForm({...warehouseForm,deskripsi:e.target.value})} placeholder="Deskripsi warehouse"/></Field>
          <div style={{ display:"flex", gap:8, justifyContent:"flex-end" }}>
            <Btn variant="secondary" onClick={()=>setShowModal(false)}>Batal</Btn>
            <Btn onClick={handleSaveWarehouse} disabled={saving}>{saving?"Menyimpan…":"Simpan"}</Btn>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default MasterPage;
